import { techLogos } from "./data"

const Carrossel = () => {
  const row = techLogos.concat(techLogos)
  return (
    <section className="k-marquee" aria-label="Tecnologias que utilizamos">
      <p className="k-marquee__title">
        <span>Stack</span> tecnologias que usamos no dia a dia
      </p>
      <div className="k-marquee__viewport">
        <div className="k-marquee__track">
          {row.map((logo, i) => (
            <div className="k-marquee__item" key={i} aria-hidden={i >= techLogos.length}>
              <img src={logo.src} alt={i < techLogos.length ? logo.name : ""} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Carrossel
